import { routePaths } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import { ChevronLeft } from "lucide-react";
import { Link, useParams } from "react-router";

import { useToast } from "@/components/ui/use-toast";
import { useTakePicture } from "@/hooks/useTakePicture";
import { useTourStop } from "@/libs/tours-detail/hooks/useTourStop";
import { useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * TODO: This file contains AI generated Code. The code in this file may not be complete.
 * We defenetly need to refactor this.
 */

export function AlternativeStorageDeliveryPage() {
  const { t } = useTranslation();

  const { id, stopId, taskId } = useParams();

  const { toast } = useToast();

  const [recipientName, setRecipientName] = useState("");

  const { deliverTourStop, uploadDeliveryProofImage, currentStop } =
    useTourStop(stopId as string);

  const { photo, takePicture } = useTakePicture();

  const currentTask = currentStop?.items.find((item) => item.id === taskId);

  const handleDeliveryProofUpload = async () => {
    await takePicture();
  };

  const handleRecipientDelivery = () => {
    if (!currentTask) {
      return;
    }

    if ((!photo || !photo.base64String) && !recipientName) {
      toast({
        title: "Fehlende Angaben",
        description:
          "Bitte nimm ein Bild auf oder beschreibe den Ablageort, um fortzufahren.",
        variant: "error",
      });
      return;
    }

    if (photo && photo.base64String) {
      uploadDeliveryProofImage(
        photo.base64String,
        currentTask.parentId,
        currentTask.id,
      );
    }

    deliverTourStop(currentTask.id, currentTask.parentId, {
      handedToName: recipientName,
    });
  };

  return (
    <div className="h-dvh  flex flex-col overflow-y-auto">
      <header className="bg-white px-4 py-6 border-b-2 border-neutral pt-safe">
        <Link
          to={routePaths.createTourStopPath(
            id as string,
            stopId as string,
            "order-delivery",
          )}
          className="mb-8 flex items-center font-medium gap-1.5 bg-slate-100 w-fit p-2 pr-4 rounded"
        >
          <ChevronLeft className="w-5 h-5" strokeWidth={2.5} />
          {t("common.back")}
        </Link>

        <h3 className="text-xl font-semibold">
          {t("alternativeStorage.header.title")}
        </h3>
      </header>

      <section className="p-4 space-y-6 overflow-y-scroll flex-1 bg-list-background">
        <div className="grid w-full items-center gap-1.5">
          <Label htmlFor="name">{t("alternativeStorage.description")}</Label>
          <Input
            type="name"
            id="name"
            placeholder="Ablageort"
            value={recipientName}
            onChange={(e) => setRecipientName(e.target.value)}
          />
        </div>

        <div
          className="grid w-full items-center gap-1.5 border-2 border-dashed border-gray-300 h-48 rounded-md cursor-pointer"
          onClick={handleDeliveryProofUpload}
        >
          {photo?.base64String ? (
            <img
              className="w-full h-full object-contain rounded-md"
              src={`data:image/png;base64,${photo.base64String}`}
              alt="Beweisfoto"
            />
          ) : (
            <span className="w-full h-full flex items-center justify-center text-gray-500">
              {t("alternativeStorage.uploadImage")}
            </span>
          )}
        </div>
      </section>

      <div className="p-4 bg-white space-y-4 border-t-2 border-neutral pb-safe">
        <Button className="w-full" onClick={handleRecipientDelivery}>
          {t("alternativeStorage.submit")}
        </Button>
      </div>
    </div>
  );
}
